"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Spinner = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _types = require("./types");
var _SpinnerSt = require("./Spinner.st.css");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/Spinner/Spinner.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class Spinner extends React.Component {
  render() {
    const _this$props = this.props,
      className = _this$props.className,
      type = _this$props.type,
      diameter = _this$props.diameter,
      isCentered = _this$props.isCentered,
      isStatic = _this$props.isStatic;
    return /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 50 50",
      className: (0, _SpinnerSt.st)(_SpinnerSt.classes.root, {
        centered: !!isCentered,
        static: !!isStatic
      }, className),
      style: {
        width: `${diameter}px`,
        height: `${diameter}px`,
        top: isCentered ? `calc(50% - ${diameter / 2}px)` : 'auto',
        left: isCentered ? `calc(50% - ${diameter / 2}px)` : 'auto'
      },
      "data-hook": this.props['data-hook'],
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      strokeWidth: type === _types.SpinnerTypes.regular ? 4 : 1,
      className: _SpinnerSt.classes.circle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 9
      }
    }));
  }
}
exports.Spinner = Spinner;
(0, _defineProperty2.default)(Spinner, "displayName", 'Spinner');
(0, _defineProperty2.default)(Spinner, "defaultProps", {
  type: _types.SpinnerTypes.regular,
  diameter: 50,
  isCentered: false,
  isStatic: false
});
//# sourceMappingURL=Spinner.js.map